import { SvgIcon, SvgIconProps } from '@mui/material';

const ExpandContent = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <path d="M0.5 13.5V8H2V12H6V13.5H0.5ZM12 6V2H8V0.5H13.5V6H12Z" fill="#currentColor" />
  </SvgIcon>
);

export default ExpandContent;
